<template>
	<div class="login-main-wrapper" >
        <div class="login-main-container">
            <slot
                name="login-col"
                :classNameLogin="'login-col'"
                :onLoginSubmit="onLoginSubmit"
                :onToggleOfficeButton="onToggleOfficeButton"
            >
                <div>teste</div>
            </slot>
        </div>
      <!--   <span class="copy copy__v2"></span>  --><!-- just for Clipboard instance -->
	</div>
</template>

<script>
    export default {
        name: 'wl-index',
        props: ['view'],
        data: function() {
            return {
                showLoading: true
            }
        },
        methods: {
            callShowLoading(){
                let vm = this
                setTimeout(() => {
                    vm.showLoading = true
                }, 500)
            },
            onLoginSubmit(){
                this.callShowLoading()
            },
            onToggleOfficeButton(type = ''){
                // enable just when page loads
                let types = ['forgot-password', 'change-password'];
                if(types.includes(type)) {
                    this.callShowLoading()
                }
            }
        },
        mounted: async function() {
            let vm = this
            $(window).on('load', (e) => {
                vm.showLoading = false
            });
        }
    }
</script>

<style scoped lang="scss">
  * {
    //background-color: #FFFF !important;
    font-family: "Manrope" !important;
    background-color: #FFFF !important;
  }
  .login-main-wrapper {
    background-color: #FFFF !important;
  }
  .login-main-container {


    display: flex !important;
    margin: 0 auto !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/wl-auth/index.vue